exports = module.exports = require("../../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2zbJhMiF6VWmmafbe3eZ8-{background:#09090b;padding:5rem 0}._17ai0Fcgsb3oqrJVlaqF2B{max-width:1280px;margin:0 auto;padding:0 1.5rem;display:flex;justify-content:center;align-items:center}.N6i4heIBchH3Ltic_m5Oa svg{width:60px}", ""]);

// exports
exports.locals = {
	"footer": "_2zbJhMiF6VWmmafbe3eZ8-",
	"footerContent": "_17ai0Fcgsb3oqrJVlaqF2B",
	"footerLogoWrapper": "N6i4heIBchH3Ltic_m5Oa"
};